import { useEffect } from 'react';

export const useOnMount = (fn: Parameters<typeof useEffect>[0]) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps -- on mount
  useEffect(fn, []);
};
